<h2 mat-dialog-title>Authorize payment</h2>

<mat-dialog-content>
    <app-authorization-consent #consentRef
        [paymentMethodType]="data.paymentMethodType"
        [authorizationType]="data.authorizationType"
        [presetActiveText]="data.activeText"
        (consentChange)="onConsentChange($event)">
    </app-authorization-consent>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button matButton type="button" (click)="onClick_cancel()">
        Cancel
    </button>
    <!-- a11y: tie the clickwrap terms to the binding submit action so
         screen readers announce them as the button's description. -->
    <button matButton color="accent" type="button"
        (click)="onClick_confirm()"
        [attr.aria-describedby]="consentRef.textElementId"
        [disabled]="!canConfirm">
        Authorize and submit payment
    </button>
</mat-dialog-actions>
